import { render, staticRenderFns } from "./ExcelIcon.vue?vue&type=template&id=656e0c88&scoped=true&"
import script from "./ExcelIcon.vue?vue&type=script&lang=ts&"
export * from "./ExcelIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ExcelIcon.vue?vue&type=style&index=0&id=656e0c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656e0c88",
  null
  
)

export default component.exports